import { render, staticRenderFns } from "./Drafts.vue?vue&type=template&id=d0b363bc&scoped=true"
import script from "./Drafts.vue?vue&type=script&lang=ts"
export * from "./Drafts.vue?vue&type=script&lang=ts"
import style0 from "./Drafts.scss?vue&type=style&index=0&id=d0b363bc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b363bc",
  null
  
)

export default component.exports